import { materialCostPerPart, round4 } from './plasticsCostMath.js';

function amount(value, name) {
  if (!['number', 'string'].includes(typeof value) ||
      (typeof value === 'string' && value.trim() === '') ||
      !Number.isFinite(Number(value)) || Number(value) < 0) {
    throw new Error(`Missing or invalid ${name}; no price was generated.`);
  }
  try {
    return round4(value);
  } catch {
    throw new Error(`Missing or invalid ${name}; no price was generated.`);
  }
}

/** Display equivalent markup; this is not a rate returned by the procedure. */
export function overheadRatePercent(ohpAmount, material, process) {
  const base = amount(material, 'material cost') + amount(process, 'process cost');
  const overhead = amount(ohpAmount, 'overhead cost');
  return base > 0 ? overhead / base * 100 : 0;
}

/** Never substitute RMPrice ($/kg) for a missing MaterialCost ($/part). */
export function costBreakdownFromSql(row) {
  const material = amount(row.MaterialCost ?? row.Material ?? row.material, 'material cost');
  const process = amount(row.MfrCost ?? row.Manufacturing ?? row.manufacturing ?? row.ProcessCost, 'process cost');
  const ohp = amount(row.oHP ?? row.OHP ?? row.OHPCost, 'overhead cost');
  const total = round4(material + process + ohp);
  if ([row.PartWeight, row.RunnerWt, row.RMPrice].every(value => value !== undefined && value !== null)) {
    const expectedMaterial = materialCostPerPart({
      partWeightGrams: row.PartWeight, runnerWeightGrams: row.RunnerWt, pricePerKg: row.RMPrice,
    });
    if (Math.abs(expectedMaterial - material) > .00015) {
      throw new Error('Stored-procedure material cost does not reconcile to weight and price; no price was generated.');
    }
  }
  if (row.TotSC !== undefined && row.TotSC !== null && Math.abs(amount(row.TotSC, 'total cost') - total) > .00015) {
    throw new Error('Stored-procedure cost components do not reconcile to the total; no price was generated.');
  }
  return { material, process, logistics: 0, ohp, total_should_cost: total, currency: 'USD/unit' };
}
